import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import RoleBasedHeader from '../../components/ui/RoleBasedHeader';
import DashboardNavigation from '../../components/ui/DashboardNavigation';
import Icon from '../../components/AppIcon';
import PersonalInformationTab from './components/PersonalInformationTab';
import ProfilePictureTab from './components/ProfilePictureTab';
import SecurityTab from './components/SecurityTab';

const UserProfileSettings = () => {
  const { userProfile } = useAuth();
  const [activeTab, setActiveTab] = useState('personal');

  const tabs = [
    { id: 'personal', label: 'Personal Information', icon: 'User' },
    { id: 'picture', label: 'Profile Picture', icon: 'Camera' },
    { id: 'security', label: 'Security', icon: 'Lock' },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'personal':
        return <PersonalInformationTab />;
      case 'picture':
        return <ProfilePictureTab />;
      case 'security':
        return <SecurityTab />;
      default:
        return <PersonalInformationTab />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <RoleBasedHeader />
      <DashboardNavigation />
      
      <div className="page-content-wrapper">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-heading font-bold text-foreground mb-2">
              Profile Settings
            </h1>
            <p className="text-muted-foreground">
              Manage your account settings and preferences
            </p>
          </div>

          {/* User Info Card */}
          <div className="bg-card rounded-xl p-6 shadow-md border border-border mb-6">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-2xl font-semibold">
                {userProfile?.full_name?.charAt(0)?.toUpperCase() || 'U'}
              </div>
              <div>
                <h2 className="text-xl font-semibold text-foreground">
                  {userProfile?.full_name || 'User'}
                </h2>
                <p className="text-sm text-muted-foreground">
                  {userProfile?.email}
                </p>
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary/10 text-primary capitalize mt-1">
                  {userProfile?.role || 'member'}
                </span>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="bg-card rounded-xl shadow-md border border-border overflow-hidden">
            <div className="border-b border-border">
              <nav className="flex -mb-px">
                {tabs?.map((tab) => (
                  <button
                    key={tab?.id}
                    onClick={() => setActiveTab(tab?.id)}
                    className={`flex items-center gap-2 px-6 py-4 text-sm font-medium border-b-2 transition-colors duration-250 ${
                      activeTab === tab?.id
                        ? 'border-primary text-primary bg-primary/5' :'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                    }`}
                  >
                    <Icon name={tab?.icon} size={18} />
                    {tab?.label}
                  </button>
                ))}
              </nav>
            </div>

            {/* Tab Content */}
            <div className="p-6">
              {renderTabContent()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileSettings;